import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from './utils.service';
import { Order, OrderLine } from '../_models/order';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  constructor(        
    private http: HttpClient,
    private auth : AuthenticationService,
    private toastr : ToastrService,
    private translate : TranslateService,
    private utils : UtilsService) 
    { }


    getOpenOrders() : Observable<Order[]>{
      //https://tweb3.plusfresc.cat/api/orders/{id_user}/{idioma}/open  
      return this.http.get<Order[]>(`${environment.API_ENDPOINT}orders/${this.auth.currentUserValue.id_user}/${this.translate.currentLang}/open`).pipe(
        catchError (error => {
          this.toastr.error(this.translate.instant('USERORDERS.ERROR_GET'));
          throw error;
        })
      );    
    }

    getClosedOrders() : Observable<Order[]>{
      //https://tweb3.plusfresc.cat/api/orders/{id_user}/invoices
      return this.http.get<Order[]>(`${environment.API_ENDPOINT}orders/${this.auth.currentUserValue.id_user}/invoices`).pipe(
        catchError (error => {
          this.toastr.error(this.translate.instant('USERORDERS.ERROR_GET'));
          throw error;
        })
      );
    }

    getOrderLines(numPedido:number) : Observable<OrderLine[]>{
      return this.http.get<OrderLine[]>(`${environment.API_ENDPOINT}orders/${this.auth.currentUserValue.id_user}/${numPedido}/show`).pipe(
        catchError (error => {
          this.toastr.error(this.translate.instant('USERORDERS.ERROR_GET'));
          throw error;
        })
      );
    }

    getClosedOrderLines(factura:string):Observable<OrderLine[]>{
      return this.http.get<OrderLine[]>(`${environment.API_ENDPOINT}orders/${this.auth.currentUserValue.id_user}/invoice/${factura}/show`).pipe(
        catchError (error => {
          this.toastr.error(this.translate.instant('USERORDERS.ERROR_GET'));
          throw error;
        })
      );
    }

    downloadPDF(factura: string): Observable<any> {
      return this.http.get(`${environment.API_ENDPOINT}utils/${this.auth.currentUserValue.id_user}/${factura}/factura`, { responseType: "blob" }).pipe(       
        catchError (error => {
          this.toastr.error(this.translate.instant('USERORDERS.ERROR_GETINVOICE'));
          throw error;
        })
      );
    }

}
